<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">老干工单查询</p>
        </div>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button>
            </div>
            <div class="search_content">
                <div class="search_inline" v-show="isSearchContent">
                    <QueryForm
                        @QuerySearch="QuerySearch"
                        :queryForm="queryForm"
                    ></QueryForm>
                </div>
                <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div>
            </div>
        </div>
        <!-- <global-tag>
            <span slot="title">老干工单查询</span>
            <div class="search" slot="search">
                <QueryForm
                    @QuerySearch="QuerySearch"
                    :queryForm="queryForm"
                ></QueryForm>
            </div>
        </global-tag> -->

        <div style="height: 20px"></div>
        <el-button type="primary" class="button" @click="createExcel"
            >导出</el-button
        >
        <div style="height: 20px"></div>

        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    :formatter="statesFormat"
                    prop="states"
                    label="处理结果"
                    align="center"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNum"
                    label="工单流水号"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="customerName"
                    label="客户姓名"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="联系地址"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="customerphone"
                    label="联系方式"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="servetypename"
                    label="服务类别"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeStart"
                    label="服务开始时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeEnd"
                    label="服务结束时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="realPeriod"
                    label="时间工作时间/分钟"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="estimateLevel"
                    :formatter="estimateLevelFormat"
                    label="客户满意度"
                    align="center"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="detailsVisit('查看', scope.row)"
                            >查看</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="height: 20px"></div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40, 100]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <VisitDialog
            ref="visitDialog"
            @updateList="getDataList"
            :show-visit.sync="showVisit"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialog>
        <VisitDialogs
            ref="visitDialogs"
            @updateList="getDataList"
            :show-visit.sync="showVisits"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialogs>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"
import globalTag from "../../components/globalTag"
import VisitDialog from "../component/visitDialog.vue"
import VisitDialogs from "../component/visitDialogs.vue"
import headLine from "../../components/headline"

export default {
    components: {
        QueryForm,
        globalTag,
        VisitDialog,
        headLine,
        VisitDialogs,
    },
    data() {
        return {
            isSearchContent: true,
            showVisit: false,
            showVisits: false,
            showTitle: "",
            queryForm: {
                orderName: "",
                customerType: "",
                serveproductName: "",
                servestationName: "",
                servePersonName: "",
            },
            auditActive: "",
            dialogVisible: false,
            tableData: [],
            orderInfo: {
                customerName: "",
            },
            totalCount: 0,
            query: {
                pageNo: 1,
                pageSize: 10,
            },
        }
    },
    created() {
        this.getDataList()
    },
    methods: {
        createExcel() {
            this.request2({
                url: "/jjyl/servicePgd/info/export",
                method: "POST",
                excel: true,
                data: {
                    customerphone: this.queryForm.customerphone,
                    pageNo: this.query.pageNo,
                    pageSize: this.query.pageSize,
                    orderNum: this.queryForm.orderNum,
                    type: this.queryForm.customerType || "4",
                    // customerType: this.queryForm.customerType,
                    customerName: this.queryForm.customerName,
                    timeStart: this.queryForm.timeStart,
                    timeEnd: this.queryForm.timeEnd,
                    position: this.queryForm.position,
                    servestationName: this.queryForm.servestationName,
                    serveproductName: this.queryForm.serveproductName,
                    servePersonName: this.queryForm.servePersonName,
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "老干工单.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        async fileChange(event) {
            const file = event.target.files[0]
            const personType = "1"
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            formData.append("file", file)
            let result = await this.$http.post(
                "/jjyl/servicePgd/info/ServicePgdExcel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code === 200) {
                this.$message.success(result.message)
                this.getDataList()
            } else {
                this.$message.warning(result.message)
            }
        },
        Reset() {
            this.queryForm = {}
            this.getDataList()
        },
        getDataList() {
            let params = {
                customerphone: this.queryForm.customerphone,
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                orderNum: this.queryForm.orderNum,
                type: this.queryForm.customerType || "4",
                customerUserType: this.queryForm.customerUserType,
                customerName: this.queryForm.customerName,
                timeStart: this.queryForm.timeStart,
                timeEnd: this.queryForm.timeEnd,
                position: this.queryForm.position,
                provinceId: this.queryForm.provinceId,
                cityId: this.queryForm.cityId,
                areaId: this.queryForm.areaId,
                streetId: this.queryForm.streetId,
                communityId: this.queryForm.communityId,
                servestationName: this.queryForm.servestationName,
                serveproductName: this.queryForm.serveproductName,
                servePersonName: this.queryForm.servePersonName,
                city: "",
                zone: "",
                street: "",
                shequ: "",
            }
            request({
                url: "/jjyl/servicePgd/info/findServicepgd",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.tableData = res.content.list
                        this.totalCount = res.content.count
                    } else {
                        this.tableData = []
                        this.totalCount = 0
                    }
                }
            })
        },
        statesFormat(row, column) {
            if (row.states === 0) {
                return "待派发"
            } else if (row.states === 1) {
                return "待处理"
            } else if (row.states === 2) {
                return "待回访"
            } else if (row.states === 3) {
                return "服务完成"
            } else if (row.states === 4) {
                return "待作废"
            } else if (row.states === 5) {
                return "已作废"
            } else if (row.states === 100) {
                return "移动终端接单"
            }
        },
        estimateLevelFormat(row, column) {
            if (row.estimateLevel === "1") {
                return "没有服务"
            } else if (row.estimateLevel === "2") {
                return "不满意"
            } else if (row.estimateLevel === "3") {
                return "服务一般"
            } else if (row.estimateLevel === "4") {
                return "基本满意"
            } else if (row.estimateLevel === "5") {
                return "非常满意"
            }
        },
        async detailsVisit(title, row) {
            if (title === "新增") {
                this.showTitle = title
                this.showVisit = true
            } else {
                this.showTitle = title
                await this.getDetails(row.id)
                if (row.states != 3) {
                    this.showVisit = true
                } else {
                    this.showVisits = true
                }
            }
            // 获取服务类型
            this.$refs.visitDialog &&
                this.$refs.visitDialog.getServiceTypeList()
            // 获取套餐类型
            this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
        },
        getDetails(id) {
            request({
                url: "/jjyl/servicePgd/info/findServicepgdById",
                method: "POST",
                data: {
                    id: id,
                },
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.orderInfo = res.content
                    } else {
                        this.orderInfo = {}
                    }
                }
            })
        },
        QuerySearch() {
            this.getDataList()
        },
        chehui(row) {
            this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/servicePgd/info/withdraw",
                    method: "POST",
                    data: {
                        id: row.id,
                        states: row.states,
                        appStates: row.appStates,
                    },
                }).then((res) => {
                    if (res.code === 200) {
                        this.getDataList()
                    }
                })
            })
        },
        //审核弹窗
        auditFun() {
            this.dialogVisible = true
        },
        handleSelectionChange(val) {},
        handleSizeChange(val) {
            this.query.pageSize = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.getDataList()
        },
    },
}
</script>

<style lang="less" scoped>
.QuerySearchBtn {
    margin-left: 60px;
}

.table-operation {
    width: 100%;
    display: flex;
    cursor: pointer;
    justify-content: center;

    div {
        flex: 1;
    }
}

.labelImportBtn {
    margin: 0 10px;

    span {
        width: 70px;
        height: 40px;
        text-align: center;
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        background-color: #409eff;
        cursor: pointer;
        color: #ffffff;
        border-radius: 5px;
    }
}

.cancellationBox {
    display: flex;
    justify-items: center;
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    .search_head {
        background: #e6e6e6;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 42px 20px 20px 20px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
    .el-icon-arrow-up {
        &::before {
            color: #000;
            font-size: 18px;
        }
    }
}
</style>
